
import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator';
import DateRange from '@/components/DateRange.vue';
import Util from '@/utils/util';
import imageConvert from '@/utils/image';

@Component({
  components: { DateRange },
})
export default class OtherPointAcitvityForm extends Vue {
  @Prop({}) private title!: string;

  @Prop({}) private subTitle!: string;

  @Prop({}) private pic!: string;

  @Prop({}) private url!: string;

  @Prop({}) private startTime!: string;

  @Prop({}) private endTime!: string;

  @Prop({ default: false }) private isEnabled!: boolean;

  @Prop({ default: false }) private loading!: boolean;

  private valid: boolean = false;

  private imgPic: any = '';

  private form = {
    title: this.title,
    subTitle: this.subTitle,
    pic: this.pic,
    url: this.url,
    imgPic: this.url,
    startTime: this.startTime,
    endTime: this.endTime,
    isEnabled: this.isEnabled,
  };

  private rules = {
    title: [this.requiredRule('優惠活動大標'), this.maxLengthRule('優惠活動大標', 100)],
    authStatus: [this.requiredRule('贈送時機點')],
    startTime: [
      this.requiredRule('活動開始時間'),
      this.lessThenRule(
        '活動開始時間',
        '活動結束時間',
        (vm: OtherPointAcitvityForm) => vm.form.endTime,
      ),
    ],
    endTime: [
      this.requiredRule('活動結束時間'),
      this.greaterThenRule(
        '活動結束時間',
        '活動開始時間',
        (vm: OtherPointAcitvityForm) => vm.form.startTime,
      ),
    ],
    pic: [
      this.validatePic((vm: OtherPointAcitvityForm) => vm.imgPic),
    ],
  };

  private get inputs() {
    return {
      title: this.title,
      subTitle: this.subTitle,
      pic: this.pic,
      url: this.url,
      startTime: this.startTime,
      endTime: this.endTime,
      isEnabled: this.isEnabled,
    };
  }

  private get datePeriod() {
    return {
      startOn: this.form.startTime,
      endOn: this.form.endTime,
    };
  }

  @Watch('inputs', { immediate: true })
  private inputsWatcher(val: any) {
    this.form = {
      ...val,
    };
    this.imgPic = this.pic;
  }

  @Watch('datePeriod')
  private datePeriodWatcher(val: any) {
    const inputs: any[] = (this.$refs.form as any).inputs.filter((i: any) => i.label === '活動開始時間' || i.label === '活動結束時間');
    inputs.forEach((input) => {
      input.validate(true);
    });
  }

  private requiredRule(column: string) {
    return (v: any) => !Util.isNullOrEmpty(v) || `${column} 為必填`;
  }

  private maxLengthRule(column: string, length: number) {
    return (v: any) => v?.length <= length || `${column} 最多 ${length} 字`;
  }

  private lessThenRule(
    column: string,
    column2: string,
    func: (vm: OtherPointAcitvityForm) => any,
  ) {
    return (v: any) => {
      const c = func(this);
      return !v || !c || v <= c || `${column}要小於${column2}`;
    };
  }

  private greaterThenRule(
    column: string,
    column2: string,
    func: (vm: OtherPointAcitvityForm) => any,
  ) {
    return (v: any) => {
      const c = func(this);
      return !v || !c || v >= c || `${column}要大於${column2}`;
    };
  }

  private validatePic(
    func: (vm: OtherPointAcitvityForm) => any,
  ) {
    return (v: any) => {
      const p = func(this);
      return !!v || !!p || '請上傳活動圖片';
    };
  }

  private handleClearImage() {
    this.form.pic = '';
    this.imgPic = '';
  }

  private changeImage(event: any) {
    if (event) {
      this.form.pic = event;
      this.imgPic = URL.createObjectURL(event);
    }
  }

  private async cancel() {
    await this.$router.back();
  }

  @Emit()
  private async submit() {
    const form = this.$refs.form as any as { validate: () => boolean };
    if (form.validate()) {
      return {
        ...this.form,
        pic: await imageConvert(this.form.pic as any),
      };
    }
    return null;
  }
}
